import { EMPLOYEE_RANGE_SEARCH } from 'lib/config/appConstants';
import {
  ENTITIES_FETCHED,
  SEARCH_CRITERIA_SPECIFIED,
  SAVED_SEARCHES_FETCHED,
  SAVED_SEARCH_EDIT,
  SAVED_SEARCH_CANCEL_EDIT,
  SAVED_SEARCH_EDIT_VIEW,
  EDIT_SEARCH_CHANGED,
  EDIT_SEARCH_UNCHANGED,
  CLEAR_SEARCH,
} from '../actions/Actions';

// Since the initial state should never change, it is wrapped in a function to prevent unintended modification.
const getInitialState = () => {
  const defaultSearchCriteria = {
    insightSearch: {
      activityDateRange: {
        // only recent data is shown by default
        minDate: new Date(new Date().getFullYear() - 2, 0, 1),
      },
    },
    employeeRangeSearch: EMPLOYEE_RANGE_SEARCH,
    propertyYearBuildRangeSearch: {
      propertyYearBuildRange: [new Date().getFullYear() - 11, new Date().getFullYear()],
      propertyYearBuildRangeTb: ['', ''],
      rangeType: 'slider',
    },
    complianceSearch: {
      dotYearRange: {
        // only recent data is shown by default
        min: new Date().getFullYear() - 3,
      },
    },
    searchOptions: {
      // We decided strict search would be best for narrowing searches, rather than the default.
      // This ensures you don't miss unexpected matches by default.
      matchAllTerms: false,
    },
  };

  return {
    defaultSearchCriteria: defaultSearchCriteria,
    currentSavedSearch: null,
    entities: [],
    isFetching: false,
    searchCriteria: { ...defaultSearchCriteria }, // Clone default search object
  };
};

function PcSearchState(state = getInitialState(), action) {
  var lookupSearch = function (id, searches = null) {
    if (id && searches && Array.isArray(searches.allList)) {
      let founds = searches.allList.filter((item) => {
        return item.id === id;
      });
      return founds.length > 0 ? founds[0] : null;
    }
    return null;
  };

  switch (action.type) {
    case ENTITIES_FETCHED:
      return {
        ...state,
        isFetching: false,
        entities: action.entities,
      };
    case SEARCH_CRITERIA_SPECIFIED:
      return {
        ...state,
        searchCriteria: action.searchCriteria,
      };
    // TODO extract the SAVED SEARCH reducers into their own file
    case SAVED_SEARCHES_FETCHED:
      return {
        ...state,
        isFetching: false,
        savedSearches: action.savedSearches,
      };
    case SAVED_SEARCH_EDIT:
      const savedSearch2 = state.savedSearches
        ? lookupSearch(action.editId, state.savedSearches)
        : null;
      const editSearch2 = savedSearch2
        ? {
            id: savedSearch2.id,
            name: savedSearch2.searchName,
            dirty: false,
            orgCriteria: { ...action.searchCriteria },
          }
        : null;
      return {
        ...state,
        currentSavedSearch: editSearch2,
        searchCriteria: action.searchCriteria,
      };
    case SAVED_SEARCH_CANCEL_EDIT:
      return {
        ...state,
        currentSavedSearch: null,
      };
    case EDIT_SEARCH_CHANGED:
      if (!state.currentSavedSearch || state.currentSavedSearch.dirty === true) {
        // No change state
        return state;
      }
      const newState1 = { ...state };
      newState1.currentSavedSearch.dirty = true;

      return newState1;
    case EDIT_SEARCH_UNCHANGED:
      if (!state.currentSavedSearch || state.currentSavedSearch.dirty === false) {
        // No change state
        return state;
      }
      const newState2 = { ...state };
      newState2.currentSavedSearch.dirty = false;

      return newState2;
    case CLEAR_SEARCH:
      return Object.assign(
        {
          savedSearches: state.savedSearches,
          favorites: state.favorites,
          userPreference: state.userPreference,
        },
        getInitialState()
      );
    case SAVED_SEARCH_EDIT_VIEW:
      if (!action.view) {
        console.log('Error - saved search - view is malformed, unable to edit');
        return {
          ...state,
        };
      }

      return {
        ...state,
        view: action.view,
      };
    default:
      return state;
  }
}

export default PcSearchState;
